import queryString from 'query-string'
import { omitBy, isNil } from 'lodash'

// TODO: The latest version of query-string has this functionality built in,
// but we can't upgrade the lib until we drop support for IE 11
export const skipNullQueryString = params => queryString.stringify(omitBy(params, isNil))
